const JOIN_PAGE_NAME = "join-page";

const POSITIONS_PAGE_NAME = "positions-page";

const EXPATS_PAGE_NAME = "expats-page";

const APPLICATION_PAGE_NAME = "application-page";

const POSITION_PAGE_NAME = "position-page";

const OPEN_APPLICATION_PAGE_NAME = "open-application-page";

const INTERNSHIPS_PAGE_NAME = "internships-page";

const SUBSCRIBE_PAGE_NAME = "subscribe-page";

const UNSUBSCRIBE_PAGE_NAME = "unsubscribe-page";

const VERIFY_SUBSCRIPTION_PAGE_NAME = "verify-subscription-page";

export {
	JOIN_PAGE_NAME,
	POSITIONS_PAGE_NAME,
	EXPATS_PAGE_NAME,
	APPLICATION_PAGE_NAME,
	POSITION_PAGE_NAME,
	OPEN_APPLICATION_PAGE_NAME,
	INTERNSHIPS_PAGE_NAME,
	SUBSCRIBE_PAGE_NAME,
	UNSUBSCRIBE_PAGE_NAME,
	VERIFY_SUBSCRIPTION_PAGE_NAME
};



// WEBPACK FOOTER //
// ./src/router/pageConstants.js